import React from "react";
import "./CategoryTable.css";
import { FaPen, FaTrash, FaCheckCircle, FaTimesCircle, FaLayerGroup } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const CategoryTable = ({ categories = [], subcategoryCounts = {}, onDelete, onEdit, canWrite = true }) => {
  const navigate = useNavigate();

  if (!categories.length) {
    return (
      <div className="no-variants-message">
        <p>No categories available yet.</p>
      </div>
    );
  }

  return (
    <div className="category-table-container">
      <table className="luxury-table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Name</th>
            <th>Subcategories</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((c) => (
            <tr key={c.category_id || c._id || c.id}>
              <td>
                {c.category_image ? (
                  <img
                    src={typeof c.category_image === 'object' ? c.category_image.url : c.category_image}
                    alt={c.category_name}
                    className="table-category-img"
                  />
                ) : (
                  <div className="no-image-placeholder">📂</div>
                )}
              </td>
              <td style={{ fontWeight: "700", color: "#181c32" }}>
                {c.category_name}
              </td>
              <td>
                <span className="status-badge type-product" style={{ fontSize: '0.8rem', padding: '4px 8px' }}>
                  {subcategoryCounts[c.category_id || c._id || c.id] || 0} Nested
                </span>
              </td>
              <td>
                <span className={`status-pill ${c.status ? 'active' : 'inactive'}`}>
                  {c.status ? (
                    <><FaCheckCircle size={12} /> Active</>
                  ) : (
                    <><FaTimesCircle size={12} /> Inactive</>
                  )}
                </span>
              </td>
              <td>
                <div className="table-actions">
                  <button
                    className="action-btn view"
                    onClick={() => navigate(`/adminDashboard/subcategories/${c.category_id || c._id || c.id}`)}
                    title="Manage Subcategories"
                  >
                    <FaLayerGroup />
                  </button>
                  {canWrite && (
                    <>
                      <button className="action-btn edit" onClick={() => onEdit(c)} title="Edit">
                        <FaPen />
                      </button>
                      <button className="action-btn delete" onClick={() => onDelete(c.category_id || c._id || c.id)} title="Delete">
                        <FaTrash />
                      </button>
                    </>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CategoryTable;
